import { AccountInfo, PublicClientApplication } from "@azure/msal-browser";
import {
  IEnsueHttpRequest,
  IEnsueHttpRequestInterceptor,
} from "../../ensue-react-system/http/ensue-http-types";
import { EnsueSession } from "../../ensue-react-system/utilities/ensue-session";
import { decodeJWT } from "./blob-utils";
import { loginRequest, msalConfig } from "../../microsoftAuthConfig";
import { appStorage } from "..";

export class HttpRequestInterceptor implements IEnsueHttpRequestInterceptor {
  private msalInstance: PublicClientApplication;
  public constructor(private __session: EnsueSession) {
    this.msalInstance = new PublicClientApplication(msalConfig);
  }
  public async intercept(request: IEnsueHttpRequest): Promise<void> {
    let token = this.__session.getAccessToken();
    if (token === "" || !token) return;
    const tokenInfo = decodeJWT(token);
    const now = Math.floor(Date.now() / 1000);
    const refreshWindow = 15 * 60; // in seconds
    const exp = tokenInfo.exp ?? 0;
    if (tokenInfo.iss && tokenInfo.iss.includes("sts.windows.net")) {
      if (exp - refreshWindow <= now && exp > now) {
        await this.msalInstance.initialize();
        try {
          const loggedInAccount = appStorage.getItem("microsoftUser");
          if (loggedInAccount && loggedInAccount !== "") {
            const freshResponse = await this.msalInstance.acquireTokenSilent({
              ...loginRequest,
              account: JSON.parse(loggedInAccount) as AccountInfo,
              forceRefresh: true,
            });
            this.__session.setAccessToken(freshResponse.accessToken);
            token = freshResponse.accessToken;
          } else {
            return;
          }
        } catch (error) {
          console.error(error);
          return;
        }
      }
    }
    request.headers?.setAuthBearerToken(token);
  }
}
